module.exports = __webpack_public_path__ + "static/img/sicbo2_en.70d520c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/sicbo2_en.png
// module id = FDIN
// module chunks = 1